import { forwardRef, ElementType } from 'react';
import { Grid as MUIGrid, GridProps } from '@mui/material';

export interface IGridProps extends GridProps {
  component?: ElementType;
}

const Grid = forwardRef<HTMLDivElement, IGridProps>((props, ref) => {
  const { children, ...restProps } = props;
  return <MUIGrid {...restProps} ref={ref}>{children}</MUIGrid>;
});

export default Grid;
